import AccountBillingList from './components/AccountBillingList';
import { bindActionCreators } from 'redux';
import withRouter from 'react-router-dom/withRouter'
import values from 'lodash/values';
import get from 'lodash/get';
import { connect } from 'react-redux';

function getPaymentMethodsForAgency(state,agencyId){
  if(agencyId){
    return values(state.entities.paymentMethods)
      .filter((p) => p.agencyId === agencyId);
      
  } else {
    return [];
  }
}

function mapStateToProps(state,props){
  return {
    paymentMethods:getPaymentMethodsForAgency(state,props.accountId),
    defaultPaymentMethodId:get(state,['entities','agencies',props.accountId,'defaultPaymentMethodId'])
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({},dispatch);
}

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(AccountBillingList));



// WEBPACK FOOTER //
// ./src/routes/AccountBillingList/index.js